<template>
  <v-dialog
    transition="dialog-bottom-transition"
    max-width="600"
    v-model="opened"
  >
    <v-card>
      <v-card-title>
        <v-icon
          v-on:click="leaveKidsForm"
          v-if="registerData.register_type === 'kid'"
        >
          mdi-arrow-left
        </v-icon>
        <span class="welcome" v-else
          >{{ $t("welcomeTo") }}
          {{
            configs && configs.institute_name
              ? configs.institute_name.config_value
              : ""
          }}</span
        >
        <v-spacer></v-spacer>
        <v-icon v-on:click="closeModal"> mdi-close </v-icon>
      </v-card-title>
      <v-card-text>
        <v-tabs
          v-model="tab"
          v-if="registerData.register_type !== 'kid' && !kidOnly"
        >
          <v-tab id="tab-login" key="tab-login">
            {{ $t("Login") }}
          </v-tab>
          <v-tab id="tab-register" key="tab-register">
            {{ $t("register") }}
          </v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
          <v-tab-item key="tab-login">
            <div v-if="!loginData.user_type" class="login-buttons mt-2 w-100">
              <v-btn
                id="student-login-btn"
                class="student-btn w-100 mb-3"
                v-on:click="showLoginForm('student')"
              >
                <SchoolIcon />
                <span class="ms-2">{{ $t("login as student") }}</span>
              </v-btn>
              <v-btn
                id="tutor-login-btn"
                class="tutor-btn w-100 mb-3"
                v-on:click="showLoginForm('tutor')"
                v-if="!reservationMode"
              >
                <TutorLoginIcon />
                <span class="ms-2">{{ $t("login as tutor") }}</span>
              </v-btn>
              <v-btn
                id="login-passcode-btn"
                class="login-passcode-btn w-100"
                v-on:click="showLoginForm('kids')"
              >
                <KeyPassIcon />
                <span class="ms-2">{{ $t("loginWithPasscode") }}</span>
              </v-btn>
            </div>
            <div v-else class="login-form mt-5 w-100 mt-2 px-3">
              <v-form ref="loginForm" v-on:submit.stop.prevent="login">
                <template
                  v-if="
                    loginData.user_type === 'tutor' ||
                    loginData.user_type === 'student'
                  "
                >
                  <v-text-field
                    id="email-input"
                    class="mb-4"
                    v-model="loginData.username"
                    v-bind:label="$t('Email')"
                    :rules="[rules.required]"
                    color="green"
                  >
                  </v-text-field>
                  <v-text-field
                    id="password-input"
                    color="green"
                    v-model="loginData.password"
                    v-bind:label="$t('Password')"
                    v-bind:append-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'"
                    v-bind:type="showPass ? 'text' : 'password'"
                    v-on:click:append="showPass = !showPass"
                    :rules="[rules.required]"
                  >
                  </v-text-field>
                  <div class="d-flex justify-content-between">
                    <v-switch
                      id="remember-me-switch"
                      v-model="loginData.remember"
                      class="mt-0"
                      inset
                      color="green"
                    >
                      <template v-slot:label>
                        <div class="switch-label">
                          {{ $t("Remember me") }}
                        </div>
                      </template>
                    </v-switch>
                    <span
                      id="forget__password__link"
                      class="forget__password__link"
                      @click="openForgetPasswordView"
                      >{{ $t("forget password") }}</span
                    >
                  </div>
                </template>
                <template v-else>
                  <v-text-field
                    id="passcode-input"
                    v-model="loginData.username"
                    v-bind:label="$t('Passcode')"
                    clearable
                    :rules="[rules.required]"
                    color="green"
                    class="mb-4"
                  >
                  </v-text-field>
                  <v-switch
                    id="remember-me-switch"
                    v-model="loginData.remember"
                    class="mt-0"
                    inset
                    color="green"
                  >
                    <template v-slot:label>
                      <div class="switch-label">
                        {{ $t("Remember me") }}
                      </div>
                    </template>
                  </v-switch>
                </template>
                <v-btn
                  id="login-complete-btn"
                  type="submit"
                  color="#008000"
                  block
                  class="mt-4 fw-normal fs-6 text-capitalize btn-sm text-white submit-btn"
                  >{{ $t("Login") }}</v-btn
                >
              </v-form>
              <template v-if="loginData.user_type === 'student'">
                <v-row class="mt-5 position-relative">
                  <v-col cols="12">
                    <v-divider color="grey"></v-divider>
                    <span
                      class="text-uppercase position-absolute top-50 start-50 translate-middle bg-white pa-3 fw-semibold"
                    >
                      {{ $t("or") }}
                    </span>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    {{ $t("loginWithSocial") }}
                  </v-col>
                </v-row>
                <v-row class="social-buttons">
                  <GoogleLogin></GoogleLogin>
                  <FacebookLogin></FacebookLogin>
                  <LinkedinLogin></LinkedinLogin>
                </v-row>
              </template>
            </div>
          </v-tab-item>
          <v-tab-item key="tab-register">
            <div
              v-if="!registerData.register_type && !kidOnly"
              class="register-buttons mt-2 w-100"
            >
              <v-btn
                id="student-register-btn"
                class="student-btn w-100 mb-3"
                v-on:click="showRegisterForm('student')"
              >
                <SchoolIcon />
                <span class="ms-2">{{ $t("registerAsStudent") }} </span>
              </v-btn>
              <v-btn
                id="tutor-register-btn"
                class="tutor-btn w-100 mb-3"
                v-on:click="showRegisterForm('tutor')"
                v-if="!reservationMode"
              >
                <TutorLoginIcon />
                <span class="ms-2">{{ $t("registerAsTutor") }} </span>
              </v-btn>
            </div>
            <div v-else class="register-form mt-5 w-100 mt-2 px-3">
              <v-form ref="registerForm" v-on:submit.prevent.stop="register">
                <template
                  v-if="
                    (registerData.register_type === 'tutor' ||
                      registerData.register_type === 'student') &&
                    !kidOnly
                  "
                >
                  <v-text-field
                    id="first-name"
                    v-model="registerData.first_name"
                    v-bind:label="$t('First Name')"
                    clearable
                    color="green"
                    :rules="[rules.required]"
                  >
                  </v-text-field>
                  <v-text-field
                    id="last-name"
                    v-model="registerData.last_name"
                    v-bind:label="$t('Last Name')"
                    clearable
                    color="green"
                    :rules="[rules.required]"
                  >
                  </v-text-field>
                  <v-text-field
                    id="email"
                    v-model="registerData.email"
                    v-bind:label="$t('Email')"
                    clearable
                    color="green"
                    :rules="[rules.required, rules.email]"
                  >
                  </v-text-field>
                  <vue-tel-input-vuetify
                    id="mobile"
                    v-model="registerData.phone_number"
                    v-bind:label="$t('Mobile')"
                    clearable
                    v-on:input="changePhoneNumber"
                    mode="international"
                    color="green"
                    :defaultCountry="$detectedCountry || 'US'"
                    :rules="[rules.required, rules.mobile]"
                    >*
                  </vue-tel-input-vuetify>
                  <v-text-field
                    id="password"
                    v-model="registerData.password"
                    v-bind:label="$t('Password')"
                    clearable
                    v-bind:append-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'"
                    v-bind:type="showPass ? 'text' : 'password'"
                    v-on:click:append="showPass = !showPass"
                    color="green"
                    :rules="[rules.required]"
                  >
                  </v-text-field>
                  <v-text-field
                    id="confirm-password"
                    v-model="registerData.confirm_password"
                    v-bind:label="$t('Confirm Password')"
                    clearable
                    v-bind:append-icon="
                      showConfirmPass ? 'mdi-eye' : 'mdi-eye-off'
                    "
                    v-bind:type="showConfirmPass ? 'text' : 'password'"
                    v-on:click:append="showConfirmPass = !showConfirmPass"
                    color="green"
                    :rules="[rules.required, rules.confirmPassword]"
                  >
                  </v-text-field>
                  <v-select
                    id="gender"
                    v-model="registerData.gender"
                    :label="$t('gender')"
                    :items="getAllGenders()"
                    color="green"
                    :rules="[rules.required]"
                    clearable
                  >
                  </v-select>
                  <v-dialog
                    ref="birthDateDialog"
                    v-model="birthDateModal"
                    presistent
                    width="290px"
                    v-bind:return-value.sync="registerData.date_of_birth"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        id="date-of-birth"
                        v-model="registerData.date_of_birth"
                        v-bind:label="$t('date_of_birth')"
                        append-icon="mdi-calendar"
                        v-bind="attrs"
                        v-on="on"
                        color="green"
                        :rules="[rules.required]"
                        clearable
                        readonly
                      >
                      </v-text-field>
                    </template>
                    <v-date-picker
                      v-model="registerData.date_of_birth"
                      color="green"
                      :max="new Date().toISOString().slice(0, 10)"
                    >
                      <v-spacer></v-spacer>
                      <v-btn text v-on:click="birthDateModal = false">
                        {{ $t("Cancel") }}
                      </v-btn>
                      <v-btn
                        text
                        color="green"
                        v-on:click="
                          $refs.birthDateDialog.save(registerData.date_of_birth)
                        "
                      >
                        {{ $t("ok") }}
                      </v-btn>
                    </v-date-picker>
                  </v-dialog>
                  <v-checkbox
                    id="is-terms-and-conditions-accepted"
                    v-model="registerData.is_terms_and_conditions_accepted"
                    color="green"
                    :rules="[rules.required]"
                  >
                    <template v-slot:label>
                      <div class="terms-conditions-label">
                        {{ $t("terms.consent") }}
                        <a
                          v-on:click.prevent="openTermsModal"
                          href="#"
                          class="mx-1"
                        >
                          {{ $t("terms.terms") }}
                        </a>
                        {{ $t("terms.and") }}
                        <a
                          v-on:click.prevent="openPrivacyModal"
                          href="#"
                          class="ms-1"
                        >
                          {{ $t("terms.privacy") }}</a
                        >
                      </div>
                    </template>
                  </v-checkbox>
                  <v-checkbox
                    id="is-marketing-emails-allowed"
                    v-model="registerData.is_marketing_emails_allowed"
                    color="green"
                  >
                    <template v-slot:label>
                      <div class="terms-conditions-label">
                        {{ $t("terms.subscribe") }}
                      </div>
                    </template>
                  </v-checkbox>
                  <v-card
                    id="kid-card"
                    v-for="(kid, i) in registerData.kids"
                    :key="i"
                    outlined
                    v-on:click="editKid(i)"
                    class="mb-3"
                  >
                    <v-card-text class="d-flex gap-5">
                      <v-icon
                        id="remove-kid-icon"
                        v-on:click.stop.prevent="removeKid(i)"
                        class="position-absolute end-0 top-25 me-5"
                      >
                        mdi-close
                      </v-icon>
                      <v-icon x-large v-if="kid.gender === 'Female'">
                        mdi-face-woman
                      </v-icon>
                      <v-icon x-large v-else> mdi-face-man </v-icon>
                      <div>
                        <h3>{{ kid.first_name }}</h3>
                        <p>{{ kid.date_of_birth }}</p>
                      </div>
                    </v-card-text>
                  </v-card>
                </template>
                <v-btn
                  id="add-kid-btn"
                  v-on:click="addKid"
                  class="w-100 mb-3 fs-6"
                  style="
                    border: 1px solid #008000;
                    text-transform: none;
                    background: white;
                    color: #008000;
                    box-shadow: none;
                  "
                  v-if="registerData.register_type === 'student' && !kidOnly"
                >
                  {{
                    registerData.kids && registerData.kids.length
                      ? $t("addAnotherKid")
                      : $t("continueWithKids")
                  }}
                </v-btn>
                <v-btn
                  id="register-complete-btn"
                  v-if="registerData.register_type !== 'kid' && !kidOnly"
                  type="submit"
                  color="#008000"
                  block
                  class="mt-4 fs-6 text-capitalize btn-sm text-white login-btn"
                  >{{ $t("register") }}</v-btn
                >
              </v-form>
              <v-form
                v-on:submit.prevent="confirmKid"
                v-if="registerData.register_type === 'kid' || kidOnly"
                ref="kidForm"
                v-model="kidFormValid"
              >
                <v-text-field
                  id="kid-first-name"
                  v-model="newKid.first_name"
                  v-bind:label="$t('First Name')"
                  color="green"
                  clearable
                  v-bind:rules="kidFormRules.firstName"
                >
                </v-text-field>
                <v-text-field
                  id="kid-last-name"
                  v-model="newKid.last_name"
                  v-bind:label="$t('Last Name')"
                  color="green"
                  clearable
                  v-bind:rules="kidFormRules.lastName"
                >
                </v-text-field>
                <v-select
                  id="kid-gender"
                  v-model="newKid.gender"
                  v-bind:label="$t('gender')"
                  color="green"
                  clearable
                  :items="getAllGenders()"
                  :rules="kidFormRules.gender"
                >
                </v-select>
                <v-dialog
                  ref="kidBirthDateDialog"
                  v-model="kidBirthDateModal"
                  presistent
                  width="290px"
                  v-bind:return-value.sync="newKid.date_of_birth"
                  color="green"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      id="kid-date-of-birth"
                      v-model="newKid.date_of_birth"
                      v-bind:label="$t('date_of_birth')"
                      append-icon="mdi-calendar"
                      v-bind="attrs"
                      v-on="on"
                      color="green"
                      clearable
                      v-bind:rules="kidFormRules.birthDate"
                      readonly
                    >
                    </v-text-field>
                  </template>
                  <v-date-picker v-model="newKid.date_of_birth" color="green">
                    <v-spacer></v-spacer>
                    <v-btn v-on:click="kidBirthDateModal = false">
                      {{ $t("Cancel") }}
                    </v-btn>
                    <v-btn
                      color="success"
                      v-on:click="
                        $refs.kidBirthDateDialog.save(newKid.date_of_birth)
                      "
                    >
                      {{ $t("ok") }}
                    </v-btn>
                  </v-date-picker>
                </v-dialog>
                <v-btn
                  id="add-kid"
                  type="submit"
                  color="#008000"
                  block
                  class="mt-4 fs-6 text-capitalize btn-sm text-white login-btn"
                >
                  {{ $t("addKid") }}
                </v-btn>
              </v-form>
              <template v-if="registerData.register_type === 'student'">
                <v-row class="mt-5 position-relative">
                  <v-col cols="12">
                    <v-divider color="grey"></v-divider>
                    <span
                      class="text-uppercase position-absolute top-50 start-50 translate-middle bg-white pa-3 fw-semibold"
                    >
                      {{ $t("or") }}
                    </span>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    {{ $t("registerWithSocial") }}
                  </v-col>
                </v-row>
                <v-row class="social-buttons">
                  <GoogleLogin></GoogleLogin>
                  <FacebookLogin></FacebookLogin>
                  <LinkedinLogin></LinkedinLogin>
                </v-row>
              </template>
            </div>
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>
    </v-card>

    <Modal
      v-bind:isOpened="termsModal"
      v-on:closeModal="termsModal = false"
      v-bind:maxWidth="1000"
      v-bind:headerTitle="$t('footer.termsAndConditions')"
      hideDefaultFooter
      v-bind:minHeight="700"
      presistent
    >
      <template #body>
        <iframe v-bind:src="termsLink" class="w-100 h-100"></iframe>
      </template>
    </Modal>
    <Modal
      v-bind:isOpened="privacyModal"
      v-on:closeModal="privacyModal = false"
      v-bind:maxWidth="1000"
      v-bind:headerTitle="$t('footer.privacyPolicy')"
      hideDefaultFooter
      v-bind:minHeight="700"
      presistent
    >
      <template #body>
        <iframe v-bind:src="privacyLink" class="w-100 h-100"></iframe>
      </template>
    </Modal>
  </v-dialog>
</template>
<script>
import GlobalMixin from "@/GlobalMixin.js"
import Modal from "./Modal.vue"
import { mapActions } from "vuex"
import FacebookLogin from "@/components/FacebookLogin.vue"
import GoogleLogin from "@/components/GoogleLogin.vue"
import LinkedinLogin from "@/components/LinkedinLogin.vue"
import moment from "moment"
import SchoolIcon from "../../icons/SchoolIcon.vue"
import TutorLoginIcon from "../../icons/TutorLoginIcon.vue"
import KeyPassIcon from "../../icons/KeyPassIcon.vue"

export default {
  name: "login-modal",
  mixins: [GlobalMixin],
  data: () => ({
    configs: null,
    tab: null,
    opened: false,
    registerMode: null,
    loginData: {
      user_type: null,
    },
    registerData: {
      register_type: null,
    },
    showPass: false,
    showConfirmPass: false,
    birthDateModal: false,
    termsLink: null,
    privacyLink: null,
    termsModal: false,
    privacyModal: false,
    kidFormValid: true,
    kidBirthDateModal: false,
    editKidId: null,
    newKid: {},
    kidOnly: false,
    reservationMode: false,
  }),
  mounted() {
    var self = this
    self.configs = JSON.parse(localStorage.getItem("configs"))
    window.addEventListener("localstorageChange", event => {
      self.configs = JSON.parse(event.detail.storage.configs)
    })
    window.addEventListener("loginModalChange", event => {
      self.opened = event.detail.opened
      self.tab = event.detail.tab
      self.kidOnly = event.detail.kidOnly
      if (self.opened) {
        sessionStorage.setItem("landing-contact", true)
      }
    })
  },
  methods: {
    openTermsModal() {
      this.termsModal = true
      if (!this.termsLink) this.getUrls()
    },
    openPrivacyModal() {
      this.privacyModal = true
      if (!this.privacyLink) this.getUrls()
    },
    getAllGenders() {
      return [
        {
          text: this.$t("Male"),
          value: "Male",
        },
        {
          text: this.$t("Female"),
          value: "Female",
        },
      ]
    },
    ...mapActions(["StoreUser"]),
    showLoginForm(mode) {
      this.loginData.user_type = mode
    },
    showRegisterForm(mode) {
      this.registerData.register_type = mode
    },
    closeModal() {
      window.dispatchEvent(
        new CustomEvent("loginModalChange", {
          detail: {
            opened: false,
            tab: 0,
          },
        })
      )
      this.loginData = {
        user_type: null,
      }
      this.registerData = {
        register_type: null,
      }
    },
    getUrls() {
      this.axios
        .get(`${process.env.VUE_APP_APIEndPoint}institutes/terms/`)
        .then(res => {
          this.termsLink = res.data.data.terms_and_conditions_url
          this.privacyLink = res.data.data.privacy_policy_url
        })
    },
    login() {
      const isValid = this.$refs.loginForm.validate()
      if (!isValid) {
        this.notify(this.$t("validateFieldsWithValidData"), "error")
        return
      }

      this.ShowLoading()
      this.axios
        .post(
          `${process.env.VUE_APP_APIEndPoint}auth/token/`,
          this.loginData,
          this.headers
        )
        .then(res => {
          if (res.data.success) {
            this.notify(this.$t("login success"), "success")
            this.StoreUser(res.data)
            const userType = res.data.user.user_type
            if (
              this.$route.name === "ProgramsList" ||
              this.$route.name === "KidsCoursesList" ||
              this.$route.name === "Courses" ||
              this.$route.name === "Webinars"
            )
              return this.$router.go()
            if (userType === "student" || userType === "kids")
              this.$router.push({ name: "BookedClasses" })
            else if (userType === "tutor")
              this.$router.push({ name: "CurrentClasses" })
            else this.$router.push({ name: "ApprovedTutors" })
          } else {
            this.notify(this.$t(res.data.Messages[0].Message), "error")
          }
        })
        .catch(error => {
          this.displayError(error)
        })
        .finally(() => {
          this.HideLoading()
        })
    },
    register() {
      const isValid = this.$refs.registerForm.validate()
      if (!isValid) {
        this.notify(this.$t("validateFieldsWithValidData"), "error")
        return
      }

      this.ShowLoading()
      let registrationType = "signup"
      if (
        this.$route.name === "Courses" ||
        this.$route.name === "KidsCoursesList" ||
        this.$route.name === "Webinars"
      )
        registrationType = "signup_with_signin"
      if (this.registerData.phone_number) {
        this.registerData.phone_number =
          this.registerData.phone_number.replaceAll(" ", "")
      }
      this.axios
        .post(
          `${process.env.VUE_APP_APIEndPoint}auth/${registrationType}/user/`,
          this.registerData,
          this.headers
        )
        .then(res => {
          if (registrationType === "signup_with_signin")
            this.StoreUser(res.data)
          if (res.data.success) {
            this.notify(this.successmsg, "success")
            this.closeModal()
          } else {
            this.notify(this.$t(res.data.Messages[0].Message), "error")
          }
        })
        .catch(error => {
          this.displayError(error)
        })
        .finally(() => {
          this.HideLoading()
        })
    },
    changePhoneNumber(val, { number, valid, country }) {
      this.registerData.phone_number = number.e164
    },
    addKid() {
      this.registerData.register_type = "kid"
      this.newKid = {}
    },
    leaveKidsForm() {
      if (this.kidOnly) {
        this.closeModal()
      } else {
        this.registerData.register_type = "student"
      }
    },
    confirmKid() {
      this.$refs.kidForm.validate()
      if (this.kidFormValid) {
        this.newKid.register_type = "kid"
        if (this.kidOnly) {
          this.axios
            .post(
              `${process.env.VUE_APP_APIEndPoint}auth/kid/add/`,
              this.newKid,
              this.headers
            )
            .then(res => {
              this.$router.go()
            })
            .catch(error => this.formatErrors(error))
        } else {
          if (this.editKidId) {
            this.registerData.kids[this.editKidId] = this.newKid
          } else {
            if (!this.registerData.kids || !this.registerData.kids.length) {
              this.registerData.kids = []
            }
            this.registerData.kids.push(this.newKid)
          }
          this.newKid = {}
          this.registerData.register_type = "student"
        }
      }
    },
    editKid(i) {
      this.editKidId = i
      this.newKid = this.registerData.kids[i]
      this.registerData.register_type = "kid"
    },
    removeKid(i) {
      this.registerData.kids.splice(i, 1)
    },
    /**
     * Open foregt password view and also close login modal
     * @returns void
     */
    openForgetPasswordView() {
      this.closeModal()
      this.$router.push({ name: "ForgetPassword" })
    },
  },
  watch: {
    opened: {
      handler() {
        this.reservationMode =
          this.$route.name === "KidsCoursesList" ||
          this.$route.fullPath.includes("reservation")
        this.loginData.user_type = null
        this.registerData.register_type = null
      },
    },
  },
  computed: {
    rules() {
      return {
        required: value => !!value || this.$t("required"),
        email: value => {
          const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || this.$t("invalidEmail")
        },
        mobile: value => {
          const pattern = /^[\+0-9]+$/
          return pattern.test(value) || this.$t("invalidPhone")
        },
        confirmPassword: value =>
          value === this.registerData.password || this.$t("passwordMismatch"),
      }
    },
    kidFormRules() {
      return {
        firstName: [v => !!v || this.$t("required")],
        lastName: [v => !!v || this.$t("required")],
        gender: [v => !!v || this.$t("required")],
        birthDate: [
          v => !!v || this.$t("required"),
          v =>
            moment(moment.now()).diff(moment(v, "YYYY-MM-DD"), "years") > 3 ||
            this.$t("kidAgeError"),
        ],
      }
    },
  },
  components: {
    Modal,
    FacebookLogin,
    GoogleLogin,
    LinkedinLogin,
    SchoolIcon,
    TutorLoginIcon,
    KeyPassIcon,
  },
}
</script>
<style scoped lang="scss">
.terms-conditions-label {
  font-size: 15px;
  font-weight: 600;
}
.switch-label {
  font-size: 15px;
  font-weight: 600;
  color: $description;
  text-transform: capitalize;
}
.welcome {
  font-weight: 600;
  font-size: 19px;
  color: $title;
}
::v-deep .v-tabs {
  font-family: "Poppins";

  .v-tabs-slider-wrapper {
    height: 0 !important;
  }

  .v-tabs-bar {
    height: 65px;
  }

  .v-slide-group__content.v-tabs-bar__content {
    box-shadow: 1px 1px 7px 0px #ccc;
    border-radius: 8px;
    margin: 0 auto;
    margin-bottom: 2rem;
    color: $title;
    padding: 10px 28px;
    min-height: 60px;

    .v-tab {
      width: 50%;
      min-height: 40px;
      text-transform: none;
      font-size: 15px;
      font-weight: 500;
      margin-left: 1rem;
    }

    .v-tab--active {
      border-bottom: 2px solid $hover-green;
      color: $hover-green;
      font-weight: 600;
      text-transform: uppercase;
    }
  }
}

::v-deep .submit-btn,
::v-deep .login-btn {
  height: 40px !important;
}
::v-deep .login-buttons,
::v-deep .register-buttons {
  font-family: "Poppins";

  button {
    box-shadow: none;

    .v-btn__content {
      justify-content: start;
      text-transform: none;
    }

    &.tutor-btn,
    &.student-btn,
    &.login-passcode-btn {
      // background-color: $white;
      // border: 1px solid rgba(0, 0, 0, 0.1);
      height: 42px;
      font-weight: 500;
      font-size: 16px;
      // color: $title;
    }
    &.student-btn {
      color: $badge-3-color;
      background: $badge-3-bg;
    }
    &.tutor-btn {
      color: $badge-1-color;
      background: $badge-1-bg;
    }
    &.login-passcode-btn {
      color: $badge-2-color;
      background: $badge-2-bg;
    }
  }
}

.social-buttons {
  ::v-deep button {
    font-family: "Poppins";
    padding: 13px !important;
    box-shadow: none;
    border: 1px solid #dadce0 !important;
    font-family: "Google Sans", arial, sans-serif;

    .v-btn__content {
      text-transform: none;

      svg {
        position: absolute;
        left: 0;
      }
    }
  }
}

::v-deep .login-form,
::v-deep .register-form {
  .theme--light.v-btn.v-btn--has-bg.login-btn {
    background-color: $grey;
    font-family: "Poppins";
    text-transform: none;
  }
}

.forget__password__link {
  cursor: pointer;
  color: $description;
  font-size: 13px;
  font-weight: 600;
  transition: all 1s;
  &:hover {
    text-decoration: underline;
    transition: all 1s;
  }
}
</style>
